export default __webpack_public_path__ + "static/ecommerce-3ff1ad0d4f323f760dc40b054ecc9616.png";